import { useFeature } from '@merchant-portal/experimentation';
import { usePageContext } from '@merchant-portal/framework';
import { hooks as i18nHooks } from 'mage-i18n';
import React, { useEffect } from 'react';
import useSetBoostersHomeSubmenu from '../../hooks/useSetBoostersHomeSubmenu';
import BoosterAppList from './BoosterAppList';
import PluginCarousel from './PluginCarousel';
import WelcomeBanner from './WelcomeBanner';
export default function BoostHome() {
    const { setPageContext = () => { } } = usePageContext();
    const t = i18nHooks.useTranslator();
    const setBoostersHomeSubmenu = useSetBoostersHomeSubmenu();
    const isPluginsEnabled = useFeature('merchant-portal.plugin-guides.enabled');
    useEffect(() => {
        setPageContext({
            title: t('core.apps.boosters-home-fe.title')
        });
        setBoostersHomeSubmenu();
    }, [t, setPageContext]);
    return (React.createElement("div", { id: 'boost-home' },
        React.createElement(WelcomeBanner, null),
        isPluginsEnabled && React.createElement(PluginCarousel, null),
        React.createElement(BoosterAppList, null)));
}
